import { render, staticRenderFns } from "./accidentCheckRule.vue?vue&type=template&id=604fa438&scoped=true"
import script from "./accidentCheckRule.vue?vue&type=script&lang=js"
export * from "./accidentCheckRule.vue?vue&type=script&lang=js"
import style0 from "./accidentCheckRule.vue?vue&type=style&index=0&id=604fa438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604fa438",
  null
  
)

export default component.exports